<template>
  <div
    class="logo-frame flex-shrink-0 flex items-center justify-center bg-white rounded-xl ring-1 ring-gray-900/10"
    :class="size === 'sm' ? 'w-11 h-11 p-1.5' : 'w-14 h-14 p-2'"
  >
    <img
      :src="src"
      :alt="alt"
      class="max-w-full max-h-full w-auto h-auto object-contain"
      loading="lazy"
      decoding="async"
    />
  </div>
</template>

<script>
export default {
  name: 'LogoFrame',
  props: {
    src: { type: String, required: true },
    alt: { type: String, default: '' },
    size: { type: String, default: 'md' },
  },
};
</script>
